import { createContext } from 'react';

export interface AudioSettingsContextProps {
  isNarratorEnabled: boolean;
  toggleNarrator: () => void;
}

export const AudioSettingsContext = createContext<AudioSettingsContextProps>({
  isNarratorEnabled: true,
  toggleNarrator: () => {},
});
